import type { SxProps, Theme } from '@mui/material';

export const dialogContentSx: SxProps<Theme> = {
  display: 'flex',
  flexDirection: 'column',
  gap: 2,
  pt: 1,
};
